var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewArrowSquareOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2723 7.5335L16.2717 3.01403L11.7522 3.01343",
    stroke: "var(--color-icon-expand-stroke, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8459 8.43959L16.27 3.0155",
    stroke: "var(--color-icon-expand-stroke, white)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8616 10.8482V15.6696C13.8616 15.8294 13.7981 15.9827 13.6851 16.0957C13.572 16.2087 13.4188 16.2722 13.2589 16.2722H3.6161C3.45626 16.2722 3.30297 16.2087 3.18995 16.0957C3.07692 15.9827 3.01343 15.8294 3.01343 15.6696V6.02675C3.01343 5.86691 3.07692 5.71362 3.18995 5.60059C3.30297 5.48757 3.45626 5.42407 3.6161 5.42407H8.43751",
    stroke: "var(--color-icon-expand-stroke, black)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrowSquareOut);
export default __webpack_public_path__ + "static/media/NewArrowSquareOut.a3fe7b11fb8d8e7b85184eed9cfa8805.svg";
export { ForwardRef as ReactComponent };